export default "__VITE_ASSET__Cz3WtSif__"